 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780062878823_COVER from '@/components/text/9780062878823_Cover'
 import TEXT9780062878823_TITLEPAGE from '@/components/text/9780062878823_Titlepage'
 import TEXT9780062878823_DEDICATION from '@/components/text/9780062878823_Dedication'
 import TEXT9780062878823_CONTENTS from '@/components/text/9780062878823_Contents'
 import TEXT9780062878823_AUTHORS_NOTE from '@/components/text/9780062878823_Authors_Note'
 import TEXT9780062878823_PROLOGUE from '@/components/text/9780062878823_Prologue'
 import TEXT9780062878823_PART_01 from '@/components/text/9780062878823_Part_01'
 import TEXT9780062878823_CHAPTER_01 from '@/components/text/9780062878823_Chapter_01'
 import TEXT9780062878823_CHAPTER_02 from '@/components/text/9780062878823_Chapter_02'
 import TEXT9780062878823_CHAPTER_03 from '@/components/text/9780062878823_Chapter_03'
 import TEXT9780062878823_CHAPTER_04 from '@/components/text/9780062878823_Chapter_04'
 import TEXT9780062878823_CHAPTER_05 from '@/components/text/9780062878823_Chapter_05'
 import TEXT9780062878823_CHAPTER_06 from '@/components/text/9780062878823_Chapter_06'
 import TEXT9780062878823_CHAPTER_07 from '@/components/text/9780062878823_Chapter_07'
 import TEXT9780062878823_CHAPTER_08 from '@/components/text/9780062878823_Chapter_08'
 import TEXT9780062878823_CHAPTER_09 from '@/components/text/9780062878823_Chapter_09'
 import TEXT9780062878823_CHAPTER_10 from '@/components/text/9780062878823_Chapter_10'
 import TEXT9780062878823_CHAPTER_11 from '@/components/text/9780062878823_Chapter_11'
 import TEXT9780062878823_CHAPTER_12 from '@/components/text/9780062878823_Chapter_12'
 import TEXT9780062878823_CHAPTER_13 from '@/components/text/9780062878823_Chapter_13'
 import TEXT9780062878823_CHAPTER_14 from '@/components/text/9780062878823_Chapter_14'
 import TEXT9780062878823_CHAPTER_15 from '@/components/text/9780062878823_Chapter_15'
 import TEXT9780062878823_CHAPTER_16 from '@/components/text/9780062878823_Chapter_16'
 import TEXT9780062878823_CHAPTER_17 from '@/components/text/9780062878823_Chapter_17'
 import TEXT9780062878823_CHAPTER_18 from '@/components/text/9780062878823_Chapter_18'
 import TEXT9780062878823_CHAPTER_19 from '@/components/text/9780062878823_Chapter_19'
 import TEXT9780062878823_CHAPTER_20 from '@/components/text/9780062878823_Chapter_20'
 import TEXT9780062878823_PART_02 from '@/components/text/9780062878823_Part_02'
 import TEXT9780062878823_CHAPTER_21 from '@/components/text/9780062878823_Chapter_21'
 import TEXT9780062878823_CHAPTER_22 from '@/components/text/9780062878823_Chapter_22'
 import TEXT9780062878823_CHAPTER_23 from '@/components/text/9780062878823_Chapter_23'
 import TEXT9780062878823_CHAPTER_24 from '@/components/text/9780062878823_Chapter_24'
 import TEXT9780062878823_CHAPTER_25 from '@/components/text/9780062878823_Chapter_25'
 import TEXT9780062878823_CHAPTER_26 from '@/components/text/9780062878823_Chapter_26'
 import TEXT9780062878823_CHAPTER_27 from '@/components/text/9780062878823_Chapter_27'
 import TEXT9780062878823_CHAPTER_28 from '@/components/text/9780062878823_Chapter_28'
 import TEXT9780062878823_CHAPTER_29 from '@/components/text/9780062878823_Chapter_29'
 import TEXT9780062878823_CHAPTER_30 from '@/components/text/9780062878823_Chapter_30'
 import TEXT9780062878823_CHAPTER_31 from '@/components/text/9780062878823_Chapter_31'
 import TEXT9780062878823_CHAPTER_32 from '@/components/text/9780062878823_Chapter_32'
 import TEXT9780062878823_CHAPTER_33 from '@/components/text/9780062878823_Chapter_33'
 import TEXT9780062878823_CHAPTER_34 from '@/components/text/9780062878823_Chapter_34'
 import TEXT9780062878823_CHAPTER_35 from '@/components/text/9780062878823_Chapter_35'
 import TEXT9780062878823_EPILOGUE from '@/components/text/9780062878823_Epilogue'
 import TEXT9780062878823_AFTERWORD from '@/components/text/9780062878823_Afterword'
 import TEXT9780062878823_ACKNWLEDGMENTS from '@/components/text/9780062878823_Acknwledgments'
 import TEXT9780062878823_END_NOTES from '@/components/text/9780062878823_End_Notes'
 import TEXT9780062878823_INDEX from '@/components/text/9780062878823_Index'
 import TEXTABOUT_THE_AUTHOR from '@/components/text/About_the_Author'
 import TEXT9780062878823_PRAISE from '@/components/text/9780062878823_Praise'
 import TEXT9780062878823_ALSOBY from '@/components/text/9780062878823_Alsoby'
 import TEXT9780062878823_BA from '@/components/text/9780062878823_BA'
 import TEXT9780062878823_BACKMATTER from '@/components/text/9780062878823_Backmatter'
 import TEXT9780062878823_COPYRIGHT from '@/components/text/9780062878823_Copyright'
 import TEXTABOUT_THE_PUBLISHER from '@/components/text/About_the_Publisher'
 import TEXT9780062878823_CHAPTER_01_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_01_Footnote_01'
 import TEXT9780062878823_CHAPTER_02_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_02_Footnote_01'
 import TEXT9780062878823_CHAPTER_06_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_06_Footnote_01'
 import TEXT9780062878823_CHAPTER_06_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_06_Footnote_02'
 import TEXT9780062878823_CHAPTER_08_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_08_Footnote_01'
 import TEXT9780062878823_CHAPTER_08_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_08_Footnote_02'
 import TEXT9780062878823_CHAPTER_09_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_09_Footnote_01'
 import TEXT9780062878823_CHAPTER_09_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_09_Footnote_02'
 import TEXT9780062878823_CHAPTER_09_FOOTNOTE_03 from '@/components/text/9780062878823_Chapter_09_Footnote_03'
 import TEXT9780062878823_CHAPTER_09_FOOTNOTE_04 from '@/components/text/9780062878823_Chapter_09_Footnote_04'
 import TEXT9780062878823_CHAPTER_11_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_11_Footnote_01'
 import TEXT9780062878823_CHAPTER_12_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_12_Footnote_01'
 import TEXT9780062878823_CHAPTER_16_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_16_Footnote_01'
 import TEXT9780062878823_CHAPTER_20_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_20_Footnote_01'
 import TEXT9780062878823_CHAPTER_22_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_22_Footnote_01'
 import TEXT9780062878823_CHAPTER_23_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_23_Footnote_01'
 import TEXT9780062878823_CHAPTER_27_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_27_Footnote_01'
 import TEXT9780062878823_CHAPTER_30_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_30_Footnote_01'
 import TEXT9780062878823_CHAPTER_31_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_31_Footnote_01'
 import TEXT9780062878823_CHAPTER_31_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_31_Footnote_02'
 import TEXT9780062878823_CHAPTER_32_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_32_Footnote_01'
 import TEXT9780062878823_CHAPTER_32_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_32_Footnote_02'
 import TEXT9780062878823_CHAPTER_33_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_33_Footnote_01'
 import TEXT9780062878823_CHAPTER_34_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_34_Footnote_01'
 import TEXT9780062878823_CHAPTER_34_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_34_Footnote_02'
 import TEXT9780062878823_CHAPTER_35_FOOTNOTE_01 from '@/components/text/9780062878823_Chapter_35_Footnote_01'
 import TEXT9780062878823_CHAPTER_35_FOOTNOTE_02 from '@/components/text/9780062878823_Chapter_35_Footnote_02'
 import TEXT9780062878823_CHAPTER_35_FOOTNOTE_03 from '@/components/text/9780062878823_Chapter_35_Footnote_03'
 import TEXT9780062878823_AFTERWORD_FOOTNOTE_01 from '@/components/text/9780062878823_Afterword_Footnote_01'
 import TEXT9780062878823_AFTERWORD_FOOTNOTE_02 from '@/components/text/9780062878823_Afterword_Footnote_02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780062878823_Cover",
 			"name" : "text/9780062878823_Cover",
 			"component" : TEXT9780062878823_COVER
 		},
 		{
 			"path" : "/text/9780062878823_Titlepage",
 			"name" : "text/9780062878823_Titlepage",
 			"component" : TEXT9780062878823_TITLEPAGE
 		},
 		{
 			"path" : "/text/9780062878823_Dedication",
 			"name" : "text/9780062878823_Dedication",
 			"component" : TEXT9780062878823_DEDICATION
 		},
 		{
 			"path" : "/text/9780062878823_Contents",
 			"name" : "text/9780062878823_Contents",
 			"component" : TEXT9780062878823_CONTENTS
 		},
 		{
 			"path" : "/text/9780062878823_Authors_Note",
 			"name" : "text/9780062878823_Authors_Note",
 			"component" : TEXT9780062878823_AUTHORS_NOTE
 		},
 		{
 			"path" : "/text/9780062878823_Prologue",
 			"name" : "text/9780062878823_Prologue",
 			"component" : TEXT9780062878823_PROLOGUE
 		},
 		{
 			"path" : "/text/9780062878823_Part_01",
 			"name" : "text/9780062878823_Part_01",
 			"component" : TEXT9780062878823_PART_01
 		},
 		{
 			"path" : "/text/9780062878823_Chapter_01",
 			"name" : "text/9780062878823_Chapter_01",
 			"component" : TEXT9780062878823_CHAPTER_01
 		},
 		{
 			"path" : "/text/9780062878823_Chapter_02",
 			"name" : "text/9780062878823_Chapter_02",
 			"component" : TEXT9780062878823_CHAPTER_02
 		},
 		{
 			"path" : "/text/9780062878823_Chapter_03",
 			"name" : "text/9780062878823_Chapter_03",
 			"component" : TEXT9780062878823_CHAPTER_03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js